export const RatioPosition = [
    {
        "Bulan": "1",
        "Tahun": 2022,
        "MonthName": "Jan",
        "TitleName" : "Current Ratio",
        "Nilai": "1451608041859.00",
        "Grup": 1
    },
    {
        "Bulan": "2",
        "Tahun": 2022,
        "MonthName": "Feb",
        "TitleName" : "Current Ratio",
        "Nilai": "1072101990324.00",
        "Grup": 1
    },
    {
        "Bulan": "3",
        "Tahun": 2022,
        "MonthName": "Mar",
        "TitleName" : "Current Ratio",
        "Nilai": "1549373085632.00",
        "Grup": 1
    },
    {
        "Bulan": "4",
        "Tahun": 2022,
        "MonthName": "Apr",
        "TitleName" : "Current Ratio",
        "Nilai": "1457762514407.00",
        "Grup": 1
    },
    {
        "Bulan": "5",
        "Tahun": 2022,
        "MonthName": "May",
        "TitleName" : "Current Ratio",
        "Nilai": "1670325426053.00",
        "Grup": 1
    },
    {
        "Bulan": "6",
        "Tahun": 2022,
        "MonthName": "Jun",
        "TitleName" : "Current Ratio",
        "Nilai": "1565291309627.00",
        "Grup": 1
    },
    {
        "Bulan": "7",
        "Tahun": 2022,
        "MonthName": "Jul",
        "TitleName" : "Current Ratio",
        "Nilai": "1649147480516.00",
        "Grup": 1
    },
    {
        "Bulan": "8",
        "Tahun": 2022,
        "MonthName": "Aug",
        "TitleName" : "Current Ratio",
        "Nilai": "1757941086827.00",
        "Grup": 1
    },
    {
        "Bulan": "9",
        "Tahun": 2022,
        "MonthName": "Sep",
        "TitleName" : "Current Ratio",
        "Nilai": "1914709105431.00",
        "Grup": 1
    },
    {
        "Bulan": "10",
        "Tahun": 2022,
        "MonthName": "Oct",
        "TitleName" : "Current Ratio",
        "Nilai": "2005701216584.00",
        "Grup": 1
    },
    {
        "Bulan": "11",
        "Tahun": 2022,
        "MonthName": "Nov",
        "TitleName" : "Current Ratio",
        "Nilai": "1949213422331.00",
        "Grup": 1
    },
    {
        "Bulan": "12",
        "Tahun": 2022,
        "MonthName": "Dec",
        "TitleName" : "Current Ratio",
        "Nilai": "2131076373409.00",
        "Grup": 1
    },

    //
    {
        "Bulan": "1",
        "Tahun": 2022,
        "MonthName": "Jan",
        "TitleName" : "Debt / Equity",
        "Nilai": "1151608041859.00",
        "Grup": 1
    },
    {
        "Bulan": "2",
        "Tahun": 2022,
        "MonthName": "Feb",
        "TitleName" : "Debt / Equity",
        "Nilai": "972101990324.00",
        "Grup": 1
    },
    {
        "Bulan": "3",
        "Tahun": 2022,
        "MonthName": "Mar",
        "TitleName" : "Debt / Equity",
        "Nilai": "1249373085632.00",
        "Grup": 1
    },
    {
        "Bulan": "4",
        "Tahun": 2022,
        "MonthName": "Apr",
        "TitleName" : "Debt / Equity",
        "Nilai": "1857762514407.00",
        "Grup": 1
    },
    {
        "Bulan": "5",
        "Tahun": 2022,
        "MonthName": "May",
        "TitleName" : "Debt / Equity",
        "Nilai": "1170325426053.00",
        "Grup": 1
    },
    {
        "Bulan": "6",
        "Tahun": 2022,
        "MonthName": "Jun",
        "TitleName" : "Debt / Equity",
        "Nilai": "1265291309627.00",
        "Grup": 1
    },
    {
        "Bulan": "7",
        "Tahun": 2022,
        "MonthName": "Jul",
        "TitleName" : "Debt / Equity",
        "Nilai": "1349147480516.00",
        "Grup": 1
    },
    {
        "Bulan": "8",
        "Tahun": 2022,
        "MonthName": "Aug",
        "TitleName" : "Debt / Equity",
        "Nilai": "1457941086827.00",
        "Grup": 1
    },
    {
        "Bulan": "9",
        "Tahun": 2022,
        "MonthName": "Sep",
        "TitleName" : "Debt / Equity",
        "Nilai": "1614709105431.00",
        "Grup": 1
    },
    {
        "Bulan": "10",
        "Tahun": 2022,
        "MonthName": "Oct",
        "TitleName" : "Debt / Equity",
        "Nilai": "1705701216584.00",
        "Grup": 1
    },
    {
        "Bulan": "11",
        "Tahun": 2022,
        "MonthName": "Nov",
        "TitleName" : "Debt / Equity",
        "Nilai": "1349213422331.00",
        "Grup": 1
    },
    {
        "Bulan": "12",
        "Tahun": 2022,
        "MonthName": "Dec",
        "TitleName" : "Debt / Equity",
        "Nilai": "2031076373409.00",
        "Grup": 1
    },

    //
    {
        "Bulan": "1",
        "Tahun": 2022,
        "MonthName": "Jan",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "951608041859.00",
        "Grup": 1
    },
    {
        "Bulan": "2",
        "Tahun": 2022,
        "MonthName": "Feb",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1272101990324.00",
        "Grup": 1
    },
    {
        "Bulan": "3",
        "Tahun": 2022,
        "MonthName": "Mar",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1749373085632.00",
        "Grup": 1
    },
    {
        "Bulan": "4",
        "Tahun": 2022,
        "MonthName": "Apr",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1657762514407.00",
        "Grup": 1
    },
    {
        "Bulan": "5",
        "Tahun": 2022,
        "MonthName": "May",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1370325426053.00",
        "Grup": 1
    },
    {
        "Bulan": "6",
        "Tahun": 2022,
        "MonthName": "Jun",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1865291309627.00",
        "Grup": 1
    },
    {
        "Bulan": "7",
        "Tahun": 2022,
        "MonthName": "Jul",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1949147480516.00",
        "Grup": 1
    },
    {
        "Bulan": "8",
        "Tahun": 2022,
        "MonthName": "Aug",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1557941086827.00",
        "Grup": 1
    },
    {
        "Bulan": "9",
        "Tahun": 2022,
        "MonthName": "Sep",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1614709105431.00",
        "Grup": 1
    },
    {
        "Bulan": "10",
        "Tahun": 2022,
        "MonthName": "Oct",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "2405701216584.00",
        "Grup": 1
    },
    {
        "Bulan": "11",
        "Tahun": 2022,
        "MonthName": "Nov",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "1749213422331.00",
        "Grup": 1
    },
    {
        "Bulan": "12",
        "Tahun": 2022,
        "MonthName": "Dec",
        "TitleName" : "Debt Service Coverage Ratio",
        "Nilai": "2231076373409.00",
        "Grup": 1
    },
]